import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import moment from "moment";
import { ROUTES } from "../../constants/routes";

import { alertMessage } from "../../services/alertService";
import {
  CustomTable,
  CustomTableHead,
  CustomTableBody,
  CustomTableRow,
  CustomTableHeader,
  OrderStatus,
  DesktopTableContainer,
  TableCellText,
  OrderNumberText,
  ClickableTableRow,
  MinWidthTableCell,
} from "../../styles/OrderHistory.styled";
import { LanguageText } from "../../styles";

interface Iprops {
  rows?: any;
  activeTab?: string;
  callback: Function;
}

function createData(
  orderNo: string,
  date: string,
  courierName: string,
  status: string,
  orderFoodMenus: any,
  order: any,
  serviceProviderId: any,
  total: any,
  spDeliveryFees: any,
  subTotal: any
) {
  return {
    orderNo,
    date,
    courierName,
    status,
    orderFoodMenus,
    order,
    serviceProviderId,
    total,
    spDeliveryFees,
    subTotal,
  };
}

const CollapsibleTable = (props: Iprops) => {
  const [rows, setRows] = React.useState<any[]>([]);
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = React.useState(props.activeTab);


  useEffect(() => {
    setActiveTab(props.activeTab);
  }, [props.activeTab]);
  

  const displayStatus = (status: any) => {
    switch (status) {
      case "pr":
        return "Preparing meal";
      case "p":
        return "Picking up order";
      case "c":
        return "Order collected";
      case "g":
        return "On the way to customer";
      case "d":
        return "Completed";
      case "r":
        return "Rejected";
      default:
        return "Pending";
    }
  };

  const handleViewDetails = (orderId: string) => {
    try {
      navigate(ROUTES.ORDER_DETAILS.replace(":id", orderId));
    } catch (error) {
      console.error("Navigation error:", error);
      alertMessage(
        "Error!",
        "Unable to navigate to order details. Please try again."
      );
    }
  };

  // Simple table row component (no collapsible functionality)
  function Row(props: { row: ReturnType<typeof createData> }) {
    const { row } = props;

    return (
      <ClickableTableRow onClick={() => handleViewDetails(row.order.id)}>
        <MinWidthTableCell>
          <OrderNumberText>{row.orderNo}</OrderNumberText>
        </MinWidthTableCell>
        <MinWidthTableCell>
          <TableCellText>{row.date}</TableCellText>
        </MinWidthTableCell>
        <MinWidthTableCell>
          <TableCellText>{row.courierName || ""}</TableCellText>
        </MinWidthTableCell>
        {activeTab === "history" ? (
          <MinWidthTableCell>
            <TableCellText>
              <OrderStatus $status={row.status}>
                {displayStatus(row.status)}
              </OrderStatus>
            </TableCellText>
          </MinWidthTableCell>
        ) : (
          <></>
        )}
        <MinWidthTableCell>
          <TableCellText>$ {row.total?.toFixed(2) || "0.00"}</TableCellText>
        </MinWidthTableCell>
      </ClickableTableRow>
    );
  }

  const prepareRows = (data: any) => {
    if (data && data.length > 0) {
      let tempRows = rows;
      tempRows = [];
      for (let i = 0; i < data.length; i++) {
        tempRows.push(
          createData(
            data[i].orderNo,
            moment(data[i].orderDate).format("DD/MM/YYYY h:mm A"),
            data[i].courierName,
            data[i].status,
            data[i].orderFoodMenus,
            data[i],
            data[i].serviceProviderId,
            data[i].total,
            data[i].spDeliveryFees,
            data[i].subTotal
          )
        );
        if (i === data.length - 1) {
          setRows(tempRows);
        }
      }
    }
  };


  useEffect(() => {
    if (props.rows && props.rows.length > 0) {
      prepareRows(props.rows);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.rows]);

  return (
    <div>
      <DesktopTableContainer>
        <CustomTable>
          <CustomTableHead>
            <CustomTableRow>
              <CustomTableHeader>
                <LanguageText>Order No.</LanguageText>
              </CustomTableHeader>
              <CustomTableHeader>
                <LanguageText>Order Time</LanguageText>
              </CustomTableHeader>
              <CustomTableHeader>
                <LanguageText>Delivery Buddy</LanguageText>
              </CustomTableHeader>
              {activeTab === "history" ? (
                <CustomTableHeader>
                  <LanguageText>Status</LanguageText>
                </CustomTableHeader>
              ) : (
                <></>
              )}
              <CustomTableHeader>
                <LanguageText>Amount</LanguageText>
              </CustomTableHeader>
            </CustomTableRow>
          </CustomTableHead>
          <CustomTableBody>
            {rows.map((row: any) => (
              <Row key={row.orderNo} row={row} />
            ))}
          </CustomTableBody>
        </CustomTable>
      </DesktopTableContainer>
    </div>
  );
};

export default CollapsibleTable;
